import { gql } from '@apollo/client';

export const GET_ALL_DOCUMENT_URLS = gql`
  query getAllDocumentURLs($transactionUUID: String!) {
    getAllDocumentURLs(transactionUUID: $transactionUUID) {
      name
      url
    }
  }
`;
